export const MEDIA_ACTIONS = {
  FETCH_MEDIA: 'MEDIA/FETCH_MEDIA',
  FETCH_MEDIA_SUCCESS: 'MEDIA/FETCH_MEDIA_SUCCESS',
  FETCH_MEDIA_ERROR: 'MEDIA/FETCH_MEDIA_ERROR',
};
